import { api } from './instance'
import type { Dashboard, ChartData } from '../types'

export const dashboardsApi = {
  getDashboards: async (includeShared = true): Promise<Dashboard[]> => {
    const { data } = await api.get('/dashboards', { params: { includeShared } })
    return data
  },

  getDashboardById: async (id: string): Promise<Dashboard> => {
    const { data } = await api.get(`/dashboards/${id}`)
    return data
  },

  createDashboard: async (dashboard: Omit<Dashboard, 'id' | 'createdAt' | 'updatedAt'>): Promise<Dashboard> => {
    const { data } = await api.post('/dashboards', dashboard)
    return data
  },

  updateDashboard: async (id: string, updates: Partial<Dashboard>): Promise<Dashboard> => {
    const { data } = await api.put(`/dashboards/${id}`, updates)
    return data
  },

  deleteDashboard: async (id: string): Promise<void> => {
    await api.delete(`/dashboards/${id}`)
  },

  getChartData: async (
    dashboardId: string,
    chartId: string,
    timeRange: string,
    timeSlice?: string,
    signalId?: string
  ): Promise<ChartData> => {
    const { data } = await api.get(`/dashboards/${dashboardId}/charts/${chartId}/data`, {
      params: { timeRange, timeSlice, signalId }
    })
    return data
  },

  exportDashboard: async (id: string): Promise<Blob> => {
    const response = await api.get(`/dashboards/${id}/export`, {
      responseType: 'blob',
    })
    return response.data
  },

  importDashboard: async (fileContent: object): Promise<Dashboard> => {
    const { data } = await api.post('/dashboards/import', fileContent)
    return data
  },
}
